import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import * as SET from 'cd-eft/_codegen_/openapi-generator/eft-set';
import * as esriProjection from '@arcgis/core/geometry/projection';
import Graphic from '@arcgis/core/Graphic';

import * as esriSymbols from '../resources/esriSymbols';
import { convertLinearUnit } from 'cd-eft/utils/structureLayerUtils';
import stores from 'cd-eft/models/Stores';

const libraryStore = stores.AppStore.projectsLibraryStore;

export class GroundPoint {
  readonly eft_type: string = 'GroundPoint';
  id: number = 0;
  name: string = '';
  description: string = '';
  visible: number = 0;
  tinable: number = 0;
  wkid: number = 0;
  x: number = 0;
  y: number = 0;
  z: number = 0;
  editing_status: string = '';
  filtered: boolean = true;

  static fromDto(dto: SET.SurveyInputPoint, wkid: number): GroundPoint {
    const result = new GroundPoint();

    if (dto.id) result.id = parseInt(dto.id);

    if (dto.pointName) result.name = dto.pointName;
    if (dto.featureDescription) result.description = dto.featureDescription;

    // if (dto.visible === 1) result.visible = true;
    // if (dto.tinable === 1) result.tinable = true;
    result.visible = dto.visible!;
    result.tinable = dto.tinable!;

    if (dto.x) result.x = dto.x;
    if (dto.y) result.y = dto.y;
    if (dto.z) result.z = dto.z;
    if (dto.editing_status) result.editing_status = dto.editing_status;

    result.wkid = wkid;

    return result;
  }

  generateGeometry(spatialReference: SpatialReference): Point {
    let geometry = new Point({
      x: this.x,
      y: this.y,
      z: convertLinearUnit(this.z, 'intl-feet', 'meters'),
      hasZ: true,
      spatialReference: libraryStore.projectSpatialReference,
    });
    if (spatialReference) {
      geometry = esriProjection.project(geometry, spatialReference) as Point;
    }
    return geometry;
  }

  generateGraphic(spatialReference: SpatialReference): Graphic {
    const geometry = this.generateGeometry(spatialReference);
    const graphic = new Graphic({ geometry: geometry, symbol: esriSymbols.groundPointSymbol });

    if (this.visible) {
      if (this.tinable) {
        graphic.symbol = this.filtered ? esriSymbols.tinablePointSymbol : esriSymbols.inactivePointSymbol;
      } else {
        graphic.symbol = esriSymbols.nonTinablePointSymbol;
      }
    } else {
      graphic.symbol = esriSymbols.invisiblePointSymbol;
    }
    graphic.attributes = this;
    return graphic;
  }
}
